module.exports = __webpack_public_path__ + "static/how-to-use-a-wallet-72b0420fd4569c25fe87a008e5fb651d.svg";